import { Tooltip, TooltipProps } from '@material-ui/core';

export const CustomTooltip = ({ children, title, ...rest }: TooltipProps) => {
  return (
    <Tooltip title={title} {...rest}>
      <div>{children}</div>
    </Tooltip>
  );
};
